<template>
    <!-- START: form -->
    <div class="form">
        <!-- START: formular -->
        <form class="needs-validation" novalidate>

            <h2 id="anschluss">
                {{ this.settings.tarif.preiseMitRabatt.type === 1
                ? 'Ihre Lieferdaten (Bestandskunden)'
                : 'Ihre Lieferdaten' }}
            </h2>

            <div class="form-collapse">

                <checkbox-input name="kunde_bestandskunde" label="Sind Sie bereits Kunde der Stadtwerke Bochum?" />

                <collapse :show="!!formData.kunde_bestandskunde">
                    <div class="row">
                        <div class="col-sm-6">
                            <text-input
                                name="kunde_kundennummer"
                                label="Ihre Kundennummer"
                                validation="required:if:kunde_bestandskunde, length:10, digits"
                                :custom-error-message="{
                                    required: 'Bitte geben Sie Ihre Kundennummer ein.',
                                }"
                            />
                        </div>
                    </div>
                </collapse>
            </div>



            <div class="radiotabs">
                <div class="nav nav-tabs form-group" role="tablist">
                    <radio-input id="meldetyp_einzug" name="kunde_meldetyp" value="einzug" label="Neue Wohnung/Haus anmelden (Einzug)" />
                    <radio-input v-if="formData.kunde_bestandskunde" id="meldetyp_wechsel" name="kunde_meldetyp" value="wechsel" label="Tarifwechsel" :infoText="this.settings.tarif.preiseMitRabatt.type === 2 ? 'Bei einem Tarifwechsel wird Ihr bisheriger Vertrag automatisch zum Laufzeitende gekündigt. Sie erhalten eine Kündigungsbestätigung und eine Schlussrechnung. Den Tarifwechsel führen wir anschließend unter einer neuen Kundennummer für Sie durch.' : ''"/>
                    <radio-input v-else id="meldetyp_wechsel" name="kunde_meldetyp" value="wechsel" label="Lieferantenwechsel" />
                </div>
                <div class="tab-content">
                    <div class="tab-pane active">

                        <div class="row">

                            <div class="col-sm-6" v-if="formData.kunde_meldetyp === 'einzug'">
                                <datepicker-input
                                    name="kunde_einzugsdatum"
                                    label="Einzugsdatum"
                                    :validation="dynamicDatepickerEinzugsdatumOptions.einzugsdatum.validation"
                                    :custom-error-message="{required: 'Bitte geben Sie ein Einzugsdatum an.'}"
                                    key="kunde_einzugsdatum"
                                    :options="dynamicDatepickerEinzugsdatumOptions.einzugsdatum.datepickerOptions" />
                            </div>
                            <div class="col-sm-6" v-if="formData.kunde_meldetyp === 'wechsel'">
                                <datepicker-input
                                    name="kunde_wunschtermin"
                                    label="Ihr Wunschtermin"
                                    :validation="dynamicDatepickerWunschterminOptions.wunschtermin.validation"
                                    :custom-error-message="{required: 'Bitte geben Sie einen Wunschtermin an.'}"
                                    key="kunde_wunschtermin"
                                    :options="dynamicDatepickerWunschterminOptions.wunschtermin.datepickerOptions" />
                            </div>


                        </div>

                        <div class="row">
                            <div class="col-sm-6">
                                <text-input
                                    v-if="settings.tab2MarktlokationsIdHelpText && settings.tab2MarktlokationsIdHelpText.length > 0"
                                    name="kunde_marktlokations_id"
                                    label="Marktlokations-ID"
                                    :validation="fieldOptions.marktlokations_id.validation"
                                    :infoText="settings.tab2MarktlokationsIdHelpText"
                                />
                                <text-input
                                    v-else
                                    name="kunde_marktlokations_id"
                                    label="Marktlokations-ID"
                                    :validation="fieldOptions.marktlokations_id.validation"
                                    infoText="Die Angabe Ihrer elfstelligen Marktlokations-ID sorgt für eine schnellere Zuordnung Ihrer Verbrauchsstelle. Damit erfolgt der Wechsel schneller und einfacher. Sie finden die Marktlokations-ID auf Ihrer Rechnung."
                                />
                            </div>
                            <div class="col-sm-6">
                                <text-input
                                    name="kunde_zaehlernummer"
                                    label="Zählernummer"
                                    :validation="fieldOptions.zaehlernummer.validation"
                                    custom-error-message="Bitte geben Sie eine Zählernummer an."
                                />
                            </div>
                            <div class="col-sm-6" v-if="formData.kunde_meldetyp === 'einzug' || (formData.kunde_bestandskunde && formData.kunde_meldetyp === 'wechsel')">
                                <text-input
                                    name="kunde_zaehlerstand"
                                    label="Zählerstand"
                                    helpText="Bitte ohne Nachkommastellen eintragen"
                                    :validation="((formData.kunde_bestandskunde && formData.kunde_meldetyp === 'wechsel') ? '' : 'required, ') + 'digits'"
                                    :custom-error-message="{required: 'Bitte geben Sie einen Zählerstand an.'}"
                                    key="kunde_zaehlerstand"
                                />
                            </div>
                            <div class="col-sm-6" v-if="formData.kunde_meldetyp === 'einzug' || (formData.kunde_bestandskunde && formData.kunde_meldetyp === 'wechsel')">
                                <datepicker-input
                                    name="kunde_zaehlerablesung"
                                    label="Tag der Ablesung"
                                    :validation="((formData.kunde_bestandskunde && formData.kunde_meldetyp === 'wechsel') ? '' : 'required, ') + fieldOptions.ablesedatum.validation"
                                    :custom-error-message="{required: 'Bitte geben Sie den Tag der Ablesung an.'}"
                                    key="kunde_zaehlerablesung"
                                    :options="fieldOptions.ablesedatum.datepickerOptions"/>
                            </div>


                            <div class="col-sm-6" v-if="formData.kunde_meldetyp === 'wechsel' && !formData.kunde_bestandskunde">
                                <combobox-input
                                    name="kunde_vorversorger"
                                    label="Vorlieferant"
                                    validation="required,requireOther:kunde_vorversorger_code"
                                    :custom-error-message="{required: 'Bitte geben Sie einen Vorlieferanten an.'}"
                                    :require-selection="true"
                                    :options="vorversorgerOptionsFiltered"
                                    key="kunde_vorversorger"
                                    @select-item="setVorversorgercode"
                                />
                            </div>
                            <div class="col-sm-6" v-if="formData.kunde_meldetyp === 'wechsel' && !formData.kunde_bestandskunde">
                                <text-input
                                    name="kunde_vorversorger_kundennummer"
                                    label="Kundennummer Vorlieferant"
                                    validation="required"
                                    custom-error-message="Bitte geben Sie die Kundennummer des Vorlieferanten an."
                                    key="kunde_vorversorger_kundennummer"
                                />
                            </div>
                            <div class="col-sm-12" v-if="formData.kunde_meldetyp === 'wechsel' && !formData.kunde_bestandskunde">
                                <checkbox-input
                                    name="kunde_vorversorger_gekuendigt"
                                    label="Ich habe bereits gekündigt"
                                    key="kunde_vorversorger_gekuendigt"
                                />
                            </div>
                            <div class="col-sm-6" v-if="formData.kunde_vorversorger_gekuendigt">
                                <datepicker-input
                                    name="kunde_vorversorger_vertragsende"
                                    label="Kündigungsdatum"
                                    key="kunde_vorversorger_vertragsende"
                                    :validation="fieldOptions.kuendigung.validation"
                                    :options="fieldOptions.kuendigung.datepickerOptions"/>
                            </div>
<!--                            <div class="col-sm-6" v-if="formData.kunde_meldetyp === 'einzug'">-->
<!--                                <datepicker-input-->
<!--                                    name="kunde_schluesseldatum"-->
<!--                                    label="Datum der Schlüsselübergabe"-->
<!--                                    :validation="fieldOptions.schluesseluebergabe.validation"-->
<!--                                    key="kunde_schluesseldatum"-->
<!--                                    :options="fieldOptions.schluesseluebergabe.datepickerOptions" />-->
<!--                            </div>-->
                            <div class="col-sm-6" v-if="formData.kunde_meldetyp === 'einzug'">
                                <datepicker-input
                                    name="kunde_schluesseldatum"
                                    label="Datum der Schlüsselübergabe"
                                    :validation="dynamicDatepickerSchluesselUebergabeOptions.schluesseluebergabe.validation"
                                    :custom-error-message="{required: 'Bitte geben Sie den Tag der Schlüsselübergabe an.'}"
                                    key="kunde_schluesseldatum"
                                    :options="dynamicDatepickerSchluesselUebergabeOptions.schluesseluebergabe.datepickerOptions"/>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            <br>

            <h2 id="bankdaten">Ihre Bankdaten</h2>

            <div class="radiotabs">
                <div class="nav nav-tabs" role="tablist">
                    <radio-input id="rechnung_sepa" name="rechnung_typ" label="SEPA-Lastschrift" value="SEPA" />
                    <radio-input id="rechnung_ueberweisung" name="rechnung_typ" label="Überweisung" value="Überweisung" />
                </div>
                <div class="tab-content">
                    <div id="tabcontentSepa" class="tab-pane" :class="{active: formData.rechnung_typ === 'SEPA'}">

                        <div class="row">
                            <div class="col-sm-6">
                                <text-input
                                    name="sepa_iban"
                                    label="IBAN"
                                    validation="required:ifEquals:rechnung_typ:SEPA, iban"
                                    :custom-error-message="{required: 'Bitte geben Sie eine IBAN an.'}"
                                    autocomplete="iban"
                                />
                            </div>
                            <div class="col-sm-6">
                                <text-input
                                    name="sepa_kontoinhaber"
                                    label="Kontoinhaber."
                                    validation="required:ifEquals:rechnung_typ:SEPA"
                                    custom-error-message="Bitte geben Sie einen Kontoinhaber an."
                                    autocomplete="name"
                                />
                            </div>
                        </div>

                        <template v-if="formData.rechnung_typ === 'SEPA'">
                            <checkbox-input
                                v-for="w in settings.willenserklaerungen.zahlung_sepa"
                                :label="w.erklaerung"
                                :name="'willenserklaerung_' + w.uid"
                                :key="w.uid"
                                :validation="w.required ? 'required' : null"
                                :custom-error-message="w.fehlermeldung || 'Bitte akzeptieren Sie die Checkbox.'"
                            />
                        </template>

                        <br>

                    </div>
                    <div id="tabcontentUeberweisung" class="tab-pane" :class="{active: formData.rechnung_typ === 'Überweisung'}">

                        <template v-if="formData.rechnung_typ === 'Überweisung'">
                            <checkbox-input
                                v-for="w in settings.willenserklaerungen.zahlung_ueberweisung"
                                :label="w.erklaerung"
                                :name="'willenserklaerung_' + w.uid"
                                :key="w.uid"
                                :validation="w.required ? 'required' : null"
                                :custom-error-message="w.fehlermeldung || 'Bitte akzeptieren Sie die Checkbox.'"
                            />
                        </template>

                        <br>

                    </div>
                </div>
            </div>

            <h2>Online-Kundencenter inkl. Online-Rechnung</h2>
            <p>
                Sie werden automatisch für das Online-Kundencenter registriert und erhalten zukünftig Ihre Rechnung online. Weitere Dokumente und Briefe senden wir Ihnen ebenfalls digital in Ihr Online-Postfach. Bequem, papierlos und damit umweltfreundlich!
            </p>
            <hidden-input name="kunde_kundencenter" :default-value="true"/>

            <template v-if="settings.tarif.postrechnung">
                <checkbox-input name="rechnung_post" :label="settings.tarif.postrechnung_erklaerung" />
            </template>

            <template v-if="!settings.hideGutschein">
                <br>

                <h2>Gutschein</h2>
                <p style="margin-top:-1rem; margin-bottom:0.5rem;">Haben Sie einen
                    <strong>
                        <a
                            data-toggle="collapse"
                            href="#collapseGutscheincode"
                            role="button"
                            :aria-expanded="gutscheincodeIsExpanded.toString()"
                            aria-controls="collapseGutscheincode"
                        >
                            Gutscheincode</a></strong>?
                </p>

                <div class="collapse" id="collapseGutscheincode">
                    <Gutschein name="gutschein" label="Geben Sie bitte diesen hier ein" :tarif_id="formData.tarif_id" :plz="formData.lieferadresse_plz" :verbrauch="formData.tarif_verbrauch" />
                </div>
            </template>

            <br>

            <div v-if="this.settings.tarif.jvl">

<!--                <p><strong>Jahresvorauszahlung</strong><br>-->
<!--                    <small>Sie können unabhängig vom Tarif bei ihrer Bestellung die Jahresvorauszahlung (JVL) nutzen. Sie erhalten dann <strong><nobr>-->
<!--                        {{ this.settings.tarif.jvl_hoehe }}% Rabatt</nobr></strong> auf den Gesamtjahresbetrag.</small></p>-->

                <jvl-checkbox-input name="jvl" label="Ja, ich möchte eine Jahresvorauszahlung (JVL) leisten." :value="this.settings.tarif.jvl_hoehe" />
                <p id="newsum" v-if="this.formData.jvl > 0"><span id="newsum1"><small>Alter Preis: <span class="sum">{{ preis_formatted_old }}</span> / Monat</small></span><br><span id="newsum2"><small>Neuer Preis: <span><span class="sum">{{ preis_formatted_new }}</span> / Monat</span></small></span></p>

            </div>
            <br>

            <h2 id="willenserklaerungen">Ihre Willenserklärung</h2>

            <p class="mb-0">
                <button type="button" class="btn btn-primary btn-sm mt-0" @click.prevent="akzeptiereAlleWillenserklaerungen('checkout')">Alles bestätigen</button>
            </p>

            <div style="display: flex; flex-flow: column; gap: 1em;">
                <checkbox-input
                    v-for="w in settings.willenserklaerungen.checkout"
                    :label="w.erklaerung"
                    :name="'willenserklaerung_' + w.uid"
                    :key="w.uid"
                    :validation="w.required ? 'required' : null"
                    :custom-error-message="w.fehlermeldung || 'Bitte akzeptieren Sie die Checkbox.'"
                />
            </div>

            <br>

            <template v-if="settings.willenserklaerungen.newsletter.length">
                <h3>Newsletter "Meine Stadtwerke"</h3>

                <checkbox-input
                    v-for="w in settings.willenserklaerungen.newsletter"
                    :label="w.erklaerung"
                    :name="'willenserklaerung_' + w.uid"
                    :key="w.uid"
                    :validation="w.required ? 'required' : null"
                    :custom-error-message="w.fehlermeldung || 'Bitte akzeptieren Sie die Checkbox.'"
                />
            </template>

            <br>

            <p><small>Mit * markierte Felder sind Pflichtfelder.</small></p>

            <div class="form-buttons">
                <button class="btn btn-secondary btn-back" type="button" @click.prevent="$emit('prev')">Zurück</button>
                <button class="btn btn-secondary btn-next" type="button" @click.prevent="$emit('next')">Weiter</button>
            </div>

        </form>
        <!-- END: formular -->
    </div>
    <!-- END: form -->
</template>
<script>
import DatepickerInput from "@/components/Form/DatepickerInput";
import TextInput from "@/components/Form/TextInput";
import CheckboxInput from "@/components/Form/CheckboxInput"
import JvlCheckboxInput from "@/components/Form/JvlCheckboxInput";
import RadioInput from "@/components/Form/RadioInput";
import ComboboxInput from "@/components/Form/ComboboxInput";
import HiddenInput from "@/components/Form/HiddenInput";
import Gutschein from "@/components/Bestellstrecke/Fields/Gutschein";
import {getVorversorger} from "@/service/getVorversorger";
import Collapse from "@/components/Collapse";
import {dateOffsetFromToday, weekdayOffsetFromToday} from "@/util/date";
import {berechneMonatspreis} from "@/util/tarif";

export default {
    name: 'BestellstreckeFormLieferung',
    components: {Collapse, RadioInput, DatepickerInput, TextInput, CheckboxInput, ComboboxInput, HiddenInput, JvlCheckboxInput, Gutschein},
    inject: ['settings'],
    props: ['formData'],
    computed: {
      vorversorgerOptionsFiltered() {
          const searchValue = this.formData.kunde_vorversorger ? this.formData.kunde_vorversorger.toLocaleLowerCase() : '';
          return this.vorversorgerOptions.filter(function (vorversorger) {
              if (this.limit > 0 && searchValue !== '' && vorversorger.name.toLocaleLowerCase().indexOf(searchValue) !== -1) {
                  this.limit--;
                  return true;
              }
              return false;
          }, {limit: 10}).map(vorversorger => ({label: vorversorger.name, value: vorversorger.name, code: vorversorger.code}));
      },
        preis_formatted_old() {
            return berechneMonatspreis(this.settings.tarif, this.formData.tarif_preis, this.formData.preisoptionen, 0).format();
        },
        preis_formatted_new() {
            return berechneMonatspreis(this.settings.tarif, this.formData.tarif_preis, this.formData.preisoptionen, this.formData.jvl).format();
        },
        dynamicDatepickerWunschterminOptions() {
          const legTarifUids = this.settings.legUids;
          const tarifUid = this.settings.tarif.uid;
          const isLegTarif = legTarifUids.includes(tarifUid.toString());
            if (isLegTarif) {
                // Kundenart Neukunde und Bestandskunde
                // Wechselart Umzug / Einzug (E01):
                // Frühestmöglicher Lieferbeginn 8 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmögliches Einzugsdatum und Datum der Schlüsselübergabe 20.06.2025
                // siehe https://taiga.unternehmen.online/project/stadtwerke-bochum-website/us/309
                if (this.formData.kunde_meldetyp === 'einzug') {
                    return {
                        wunschtermin: {
                            datepickerOptions: {
                                minDate: dateOffsetFromToday(9),
                                maxDate: dateOffsetFromToday(182),
                            },
                            validation: 'required, date, dateOffsetRange:9:182',
                        },
                    }
                } else {
                    // Kundenart Bestandskunde
                    // Wechselart Tarifwechsel (E02)
                    // Frühestmöglicher Wunschtermin 20 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmöglicher Wunschtermin 02.07.2025
                    // Kundenart Neukunde
                    // Wechselart Lieferantenwechsel (E03)
                    // Frühestmöglicher Wunschtermin 20 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmöglicher Wunschtermin 02.07.2025
                    // siehe https://taiga.unternehmen.online/project/stadtwerke-bochum-website/us/309
                    return {
                        wunschtermin: {
                            datepickerOptions: {
                                minDate: dateOffsetFromToday(21),
                                maxDate: dateOffsetFromToday(182),
                            },
                            validation: 'required, date, dateOffsetRange:21:182',
                        },
                    }
                }
            } else {
              // InBo
              if (this.settings.tarif.preiseMitRabatt.type === 1) {
                  // LV 02.05.2025 Für InBo, Neukunde und Lieferantenwechsel frühestmöglicher Termin 01.07.2025
                  // https://taiga.unternehmen.online/project/stadtwerke-bochum-website/issue/258
                  if (!this.formData.kunde_bestandskunde && this.formData.kunde_meldetyp === 'wechsel') {
                      return {
                          wunschtermin: {
                              datepickerOptions: {
                                  minDate: new Date(2025, 6, 1),
                                  maxDate: dateOffsetFromToday(182),
                              },
                              // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                              validation: 'required, date, isAfterOrEqualSpecificDate:01.07.2025, dateOffset:182',
                          },
                      }
                  } else {
                      return {
                          wunschtermin: {
                              datepickerOptions: {
                                  minDate: dateOffsetFromToday(14),
                                  maxDate: dateOffsetFromToday(182),
                              },
                              // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                              // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                              validation: 'required, date, dateOffsetRange:14:182',
                          },

                      }
                  }
              }
              // LV 02.05.2025 Für ExBo immer frühestmöglicher Termin 01.07.2025
              // https://taiga.unternehmen.online/project/stadtwerke-bochum-website/issue/258
              if (this.settings.tarif.preiseMitRabatt.type === 2) {
                  return {
                      wunschtermin: {
                          datepickerOptions: {
                              minDate: new Date(2025, 6, 1),
                              maxDate: dateOffsetFromToday(182),
                          },
                          // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                          // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                          validation: 'required, date, isAfterOrEqualSpecificDate:01.07.2025, dateOffset:182',
                      },
                  }
              }
          }
            return {
                wunschtermin: {
                    datepickerOptions: {
                        minDate: dateOffsetFromToday(14),
                        maxDate: dateOffsetFromToday(182),
                    },
                    // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                    // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                    validation: 'required, date, dateOffsetRange:14:182',
                },
            }

        },
        dynamicDatepickerEinzugsdatumOptions() {
            const legTarifUids = this.settings.legUids;
            const tarifUid = this.settings.tarif.uid;
            const isLegTarif = legTarifUids.includes(tarifUid.toString());
            if (isLegTarif) {
                // Kundenart Neukunde und Bestandskunde
                // Wechselart Umzug / Einzug (E01):
                // Frühestmöglicher Lieferbeginn 8 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmögliches Einzugsdatum und Datum der Schlüsselübergabe 20.06.2025
                // siehe https://taiga.unternehmen.online/project/stadtwerke-bochum-website/us/309
                if (this.formData.kunde_meldetyp === 'einzug') {
                    return {
                        einzugsdatum: {
                            datepickerOptions: {
                                minDate: dateOffsetFromToday(9),
                                maxDate: dateOffsetFromToday(182),
                            },
                            validation: 'required, date, dateOffsetRange:9:182',
                        },
                    }
                } else {
                    // Kundenart Bestandskunde
                    // Wechselart Tarifwechsel (E02)
                    // Frühestmöglicher Wunschtermin 20 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmöglicher Wunschtermin 02.07.2025
                    // Kundenart Neukunde
                    // Wechselart Lieferantenwechsel (E03)
                    // Frühestmöglicher Wunschtermin 20 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmöglicher Wunschtermin 02.07.2025
                    // siehe https://taiga.unternehmen.online/project/stadtwerke-bochum-website/us/309
                    return {
                        einzugsdatum: {
                            datepickerOptions: {
                                minDate: dateOffsetFromToday(21),
                                maxDate: dateOffsetFromToday(182),
                            },
                            validation: 'required, date, dateOffsetRange:21:182',
                        },
                    }
                }
            } else {
                // InBo
                if (this.settings.tarif.preiseMitRabatt.type === 1) {
                    // LV 02.05.2025 Für InBo, Neukunde und Lieferantenwechsel frühestmöglicher Termin 01.07.2025
                    // https://taiga.unternehmen.online/project/stadtwerke-bochum-website/issue/258
                    // LV 15.05.2025 Ergänzung: Neukunden mit der Wechselart “Neue Wohnung/Haus anmelden (Einzug)” → immer 14 Tage in die Zukunft
                    // Bestandskunden mit der Wechselart “Neue Wohnung/Haus anmelden (Einzug)” → immer 14 Tage in die Zukunft
                    // https://taiga.unternehmen.online/project/stadtwerke-bochum-website/issue/278
                    if (!this.formData.kunde_bestandskunde && this.formData.kunde_meldetyp === 'wechsel') {
                        return {
                            einzugsdatum: {
                                datepickerOptions: {
                                    minDate: new Date(2025, 6, 1),
                                    maxDate: dateOffsetFromToday(182),
                                },
                                // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                                // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                                validation: 'required, date, isAfterOrEqualSpecificDate:01.07.2025, dateOffset:182',
                            },
                        }
                    } else if (!this.formData.kunde_bestandskunde && this.formData.kunde_meldetyp === 'einzug') {
                        return {
                            einzugsdatum: {
                                datepickerOptions: {
                                    minDate: dateOffsetFromToday(14),
                                    maxDate: dateOffsetFromToday(182),
                                },
                                // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                                // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                                validation: 'required, date, dateOffsetRange:14:182',
                            },

                        }
                    } else if (this.formData.kunde_bestandskunde && this.formData.kunde_meldetyp === 'einzug') {
                        return {
                            einzugsdatum: {
                                datepickerOptions: {
                                    minDate: dateOffsetFromToday(14),
                                    maxDate: dateOffsetFromToday(182),
                                },
                                // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                                // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                                validation: 'required, date, dateOffsetRange:14:182',
                            },

                        }
                    } else {
                        return {
                            einzugsdatum: {
                                datepickerOptions: {
                                    minDate: dateOffsetFromToday(-42),
                                    maxDate: dateOffsetFromToday(182),
                                },
                                // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                                // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                                validation: 'required, date, dateOffsetRange:-42:182',
                            },

                        }
                    }
                }
                // LV 02.05.2025 Für ExBo immer frühestmöglicher Termin 01.07.2025
                // https://taiga.unternehmen.online/project/stadtwerke-bochum-website/issue/258
                if (this.settings.tarif.preiseMitRabatt.type === 2) {
                    return {
                        einzugsdatum: {
                            datepickerOptions: {
                                minDate: new Date(2025, 6, 1),
                                maxDate: dateOffsetFromToday(182),
                            },
                            // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                            // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                            validation: 'required, date, isAfterOrEqualSpecificDate:01.07.2025, dateOffset:182',
                        },
                    }
                }
            }

            return {
                einzugsdatum: {
                    datepickerOptions: {
                        minDate: dateOffsetFromToday(-42),
                        maxDate: dateOffsetFromToday(182),
                    },
                    // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                    // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                    validation: 'required, date, dateOffsetRange:-42:182',
                },
            }
        },
        dynamicDatepickerSchluesselUebergabeOptions() {
            const legTarifUids = this.settings.legUids;
            const tarifUid = this.settings.tarif.uid;
            const isLegTarif = legTarifUids.includes(tarifUid.toString());
            if (isLegTarif) {
                // Kundenart Neukunde und Bestandskunde
                // Wechselart Umzug / Einzug (E01):
                // Frühestmöglicher Lieferbeginn 8 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmögliches Einzugsdatum und Datum der Schlüsselübergabe 20.06.2025
                // siehe https://taiga.unternehmen.online/project/stadtwerke-bochum-website/us/309
                if (this.formData.kunde_meldetyp === 'einzug') {
                    return {
                        schluesseluebergabe: {
                            datepickerOptions: {
                                minDate: dateOffsetFromToday(9),
                                maxDate: dateOffsetFromToday(182),
                            },
                            validation: 'required, date, dateOffsetRange:9:182',
                        },
                    }
                } else {
                    // Kundenart Bestandskunde
                    // Wechselart Tarifwechsel (E02)
                    // Frühestmöglicher Wunschtermin 20 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmöglicher Wunschtermin 02.07.2025
                    // Kundenart Neukunde
                    // Wechselart Lieferantenwechsel (E03)
                    // Frühestmöglicher Wunschtermin 20 Kalendertage in der Zukunft. Beispiel Kunde will heute (11.06.2025) bestellen. Nächstmöglicher Wunschtermin 02.07.2025
                    // siehe https://taiga.unternehmen.online/project/stadtwerke-bochum-website/us/309
                    return {
                        schluesseluebergabe: {
                            datepickerOptions: {
                                minDate: dateOffsetFromToday(21),
                                maxDate: dateOffsetFromToday(182),
                            },
                            validation: 'required, date, dateOffsetRange:21:182',
                        },
                    }
                }
            } else {
                if (this.settings.tarif.preiseMitRabatt.type === 1) {
                    return {
                        schluesseluebergabe: {
                            datepickerOptions: {
                                minDate: dateOffsetFromToday(14),
                                maxDate: dateOffsetFromToday(182),
                            },
                            // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                            // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                            validation: 'required, date, dateOffsetRange:14:182',
                        },
                    }
                }
                // LV 02.05.2025 Für ExBo immer frühestmöglicher Termin 01.07.2025
                // https://taiga.unternehmen.online/project/stadtwerke-bochum-website/issue/258
                if (this.settings.tarif.preiseMitRabatt.type === 2) {
                    return {
                        schluesseluebergabe: {
                            datepickerOptions: {
                                minDate: new Date(2025, 6, 1),
                                maxDate: dateOffsetFromToday(182),
                            },
                            // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                            // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                            validation: 'required, date, isAfterOrEqualSpecificDate:01.07.2025, dateOffset:182',
                        },
                    }
                }
            }
            return {
                schluesseluebergabe: {
                    datepickerOptions: {
                        minDate: dateOffsetFromToday(-42),
                        maxDate: dateOffsetFromToday(182),
                    },
                    // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                    // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                    validation: 'required, date, dateOffsetRange:-42:182',
                },
            }
        }
    },
    data: () => ({
       // Vorversorger
        vorversorgerOptions: [],
        vorversorgerLoading: false,
        fieldOptions: {
            einzugsdatum: {
                datepickerOptions: {
                    minDate: dateOffsetFromToday(-42),
                    maxDate: dateOffsetFromToday(182),
                },
                validation: 'required, date, dateOffsetRange:-42:182'
            },
            schluesseluebergabe: {
                datepickerOptions: {
                    minDate: dateOffsetFromToday(-42),
                    maxDate: dateOffsetFromToday(182),
                },
                validation: 'required, date, dateOffsetRange:-42:182',
            },
            ablesedatum: {
                datepickerOptions: {
                    minDate: dateOffsetFromToday(-42),
                    maxDate: new Date(),
                },
                validation: 'dateOffsetRange:-42:0',
            },
            wunschtermin: {
                datepickerOptions: {
                    minDate: dateOffsetFromToday(14),
                    maxDate: dateOffsetFromToday(182),
                },
                // LV 22.05.2024 Ticket 6862 Validierung Wunschtermin
                // validation: 'required, date, dateOffsetRangeWeekday:14:182',
                validation: 'required, date, dateOffsetRange:14:182',
            },
            kuendigung: {
                datepickerOptions: {
                    minDate: weekdayOffsetFromToday(2),
                    maxDate: dateOffsetFromToday(182),
                },
                validation: 'date, dateOffsetRangeWeekday:2:182',
            },
            zaehlernummer: {
                validation: 'required'
            },
            marktlokations_id: {
                validation: 'marktlokationsId'
            },
        },
        gutscheincodeIsExpanded: false
    }),
    mounted() {
        // Falls ExBo (type === 2) soll Lieferantenwechsel vorausgewählt sein
        if (this.settings.tarif.preiseMitRabatt.type === 2) {
            this.$parent.setValue('kunde_meldetyp', 'wechsel');
        }
      this.loadVorversorger();
      this.setZaehlernummerValidation();

      if (typeof window.tab2mounted === 'function') {
          window.tab2mounted();
      }
    },
    methods: {
        onSubmit() {
            console.log('submit tab 1')
            console.trace()
        },
        akzeptiereAlleWillenserklaerungen(art) {
            this.settings.willenserklaerungen[art].forEach(w => {
                this.$parent.setValue('willenserklaerung_' + w.uid, true);
            })
        },
        async loadVorversorger() {
            this.vorversorgerLoading = true;
            getVorversorger(this.settings.vorversorgerUrl, this.settings.tarif.commodity)
                .then(data => {
                    this.vorversorgerOptions = data;
                    this.vorversorgerLoading = false;
                })
                .catch(() => this.vorversorgerLoading = false)
        },
        setVorversorgercode(data){
            this.$parent.setValue('kunde_vorversorger_code',  data.code)
        },
        setZaehlernummerValidation(){
            if(this.settings.tarif.preiseMitRabatt.type === 1) // InBo
                this.fieldOptions.zaehlernummer.validation = 'required,zaehlernummer';
        },
        toggleGutscheincodeCollapse() {
            this.gutscheincodeIsExpanded = !this.gutscheincodeIsExpanded;
        }
    }
}
</script>
